import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { CellContext } from '@tanstack/react-table';

export interface InvoiceListTotalTTCCellProps
  extends CellContext<InvoiceModel, InvoiceModel['totalTTC']> {}

export const InvoiceListTotalTTCCell = (
  props: InvoiceListTotalTTCCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack justifyContent="flex-end">
      {getValue() ? toCurrencyString(getValue(), row.original.currency) : '-'}
    </Stack>
  );
};
